import { memo, useContext, useMemo } from 'react';
import { DealCommentsContext } from '~/contexts/deal-comments';
import { DEAL_COMMENT_TYPE } from '~/lib/discussions/constants';

function CommentFilterPaginationInfo() {
  const {
    itemsCount,
    commentsTotal,
    size,
    itemsPerPage,
    type,
    enableManualPagination,
    query,
  } = useContext(DealCommentsContext);

  const manualPaginationInfo = useMemo(() => {
    return (
      <div>
        Showing <span>{(size - 1) * itemsPerPage + 1}</span>
        {' - '}
        <span>{Math.min(size * itemsPerPage, commentsTotal)} </span>
        of <span>{commentsTotal}</span>{' '}
        {type === DEAL_COMMENT_TYPE.QUESTION ? 'questions' : 'reviews'}
      </div>
    );
  }, [commentsTotal, itemsPerPage, size, type]);

  const scrollPaginationInfo = useMemo(() => {
    return (
      <div>
        Showing <span>{itemsCount}</span> of{' '}
        <span>{query ? itemsCount : commentsTotal}</span>{' '}
        {type === DEAL_COMMENT_TYPE.QUESTION ? 'questions' : 'reviews'}
      </div>
    );
  }, [commentsTotal, itemsCount, query, type]);

  return (
    <>{enableManualPagination ? manualPaginationInfo : scrollPaginationInfo}</>
  );
}

export default memo(CommentFilterPaginationInfo);
